import React, { useState, useEffect, useRef } from 'react';
import api from "../../../api/index";
import Cookies from "js-cookie";
function Demo () {

    const [frame1, setFrame1] = useState('');
    const [frame2, setFrame2] = useState('');
    const [frame3, setFrame3] = useState('');

    useEffect(() => {
      // quick fix for disabling the rotate your phone message in demo modus
      document.querySelector('#landscape_disabled-message').style.display = "none";
    });
    useEffect(() => {
      //get avatars
      api.getAvatarSettings().then((response) => {
        if (response.status === 200) {
            const data = response.data;
            let avatars = data;

                  //create new game
      api.createNewGame(1, 3, 10).then((response) => {
        if(response.status === 200){
          Cookies.set("game_id", response.data.secret);
          Cookies.set("game_code", response.data.game_code);

          //register players
          api.registerPlayer(response.data.secret, 'none', 'player1').then((response) => {
            if(response.status === 200){
              const player_id = response.data.player_id;
              Cookies.set("player_id_1", player_id);
              Cookies.set("user_name_1", response.data.user_name);
              Cookies.set("group_id", response.data.group_id);

              api.confirmGroup(player_id).then(response => {
                if (response.status === 200) {
                  api.selectRole(player_id, "earth").then(result => {
                    if(result.status === 200){
                      api.createQuestions(player_id).then(result => {
                        if(result.status === 200){
                          setFrame1(window.location.origin + '/app/game/overview/?demo=true&player=1');
                        }
                      });
                    }
                  });
                }
              });
            }
          });

         setTimeout(()=> {
          api.registerPlayer(response.data.secret, 'none', 'player2').then((response) => {
            if(response.status === 200){
              if(response.status === 200){
                const player_id = response.data.player_id;
                Cookies.set("player_id_2", player_id);
                Cookies.set("user_name_2", response.data.user_name);
                Cookies.set("group_id", response.data.group_id);
  
                api.confirmGroup(player_id).then(response => {
                  if (response.status === 200) {
                    api.selectRole(player_id, "reading").then(result => {
                      if(result.status === 200){
                        api.createQuestions(player_id).then(result => {
                          if(result.status === 200){
                            setFrame2(window.location.origin + '/app/game/overview/?demo=true&player=2');
                          }
                        });
                      }
                    });
                  }
                });
              }
            }
          });
         }, 1000);

         setTimeout(() => {
          api.registerPlayer(response.data.secret, 'none', 'player3').then((response) => {
            if(response.status === 200){
              if(response.status === 200){
                const player_id = response.data.player_id;
                Cookies.set("player_id_3", player_id);
                Cookies.set("user_name_3", response.data.user_name);
                Cookies.set("group_id", response.data.group_id);
  
                api.confirmGroup(player_id).then(response => {
                  if (response.status === 200) {
                    api.selectRole(player_id, "nature").then(result => {
                      if(result.status === 200){
                        api.createQuestions(player_id).then(result => {
                          if(result.status === 200){
                            setFrame3(window.location.origin + '/app/game/overview/?demo=true&player=3');
                          }
                        });
                      }
                    });
                  }
                });
              }
            }
          });
         }, 2000)

          
        }
      });
        }
      });

      document.body.classList.add('demo-body');

    }, []);
    return (
        <div className="demoContainer">
            <div className="demoColumn">
              <iframe className="demoFrame" src={frame1} width="100%" height="100%" >
                <p>loading....</p>
              </iframe>
            </div>
            <div className="demoColumn">
              <iframe className="demoFrame" src={frame2} width="100%" height="100%">
                <p>loading....</p>
              </iframe>
            </div>
            <div className="demoColumn">
              <iframe className="demoFrame" src={frame3} width="100%" height="100%">
                <p>loading....</p>
              </iframe>
            </div>
        </div>
    )
}

export default Demo;